import { useI18n } from "@/i18n/I18n";
import { cn } from "@/lib/utils";

export const UsageGauge = ({ label, used, limit, testId }) => {
  const { t, fmtNum } = useI18n();
  const unlimited = limit == null || limit < 0;
  const pct = unlimited ? 8 : limit === 0 ? 100 : Math.min(100, (used / limit) * 100);
  const color = unlimited ? "bg-emerald-500" : pct >= 90 ? "bg-red-500" : pct >= 70 ? "bg-amber-500" : "bg-emerald-500";
  return (
    <div data-testid={testId} className="space-y-2">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</span>
        <span className="font-mono text-sm text-slate-900">
          {fmtNum(used)} <span className="text-slate-400">/ {unlimited ? t("common.unlimited") : fmtNum(limit)}</span>
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
        <div className={cn("h-full rounded-full transition-[width] duration-500", color)} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
